import React from 'react'
import { SpecialistsSearchPage } from './SpecialistsSearchPage'

const SpecialistsSearchFavoritesPage = () => <SpecialistsSearchPage onlyFavorites />

export { SpecialistsSearchFavoritesPage }
